import React from "react";
import { Input } from "../input";

type OTPInputProps = {
  length?: number;
  onChangeOTP: (otp: string) => void;
};

const OTPInput: React.FC<OTPInputProps> = ({ length = 6, onChangeOTP }) => {
  const [otp, setOtp] = React.useState<string[]>(Array(length).fill(""));
  const inputsRef = React.useRef<HTMLInputElement[] | null[]>([]);

  React.useEffect(() => {
    onChangeOTP(otp.join(""));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otp]);

  const handleChange = (value: string, index: number): void => {
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (
    error: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ): void => {
    if (error.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>): void => {
    event.preventDefault();
    const pasted = event.clipboardData.getData("text").slice(0, length);
    const digits = pasted.split("").filter((char) => /^\d$/.test(char));
    if (digits.length === length) {
      setOtp(digits);
      inputsRef.current[length - 1]?.focus();
    }
  };

  return (
    <div className="flex gap-2 justify-center">
      {otp.map((digit, indexKey) => (
        <Input
          key={indexKey}
          ref={(element) => (inputsRef.current[indexKey] = element)}
          className="w-11 h-11 text-xl text-center border-2 rounded-lg focus:outline-none focus:blue-3  focus:border-primary"
          inputMode="numeric"
          maxLength={1}
          type="text"
          value={digit}
          onPaste={handlePaste}
          onChange={(error) => {
            handleChange(error.target.value, indexKey);
          }}
          onKeyDown={(error) => {
            handleKeyDown(error, indexKey);
          }}
        />
      ))}
    </div>
  );
};

export default OTPInput;
